import React from 'react';

export type ShowIfProps = {
    showIf?: boolean | string;
    children?: React.ReactNode | null;
};

export const ShowIf: React.FC<ShowIfProps> = ({ showIf, children }) => {
    return showIf ? <>{children}</> : null;
};
